<template>
    <div class="card">
        <DataTable
            :rows="numberOfRows"
            v-model:first="offset"
            :lazy="true"

            :value="allPools"
            ref="dt"
            dataKey="id"
            :paginator="true"
            @page="onPage"
            :rowHover="true"
            :loading="loading"
            responsiveLayout="scroll"
            :totalRecords="totalRecords"
            :rowsPerPageOptions="[5, 10, 20, 50]"
            paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
        >
            <template #empty> No pools available. </template>
            <template #loading> Loading Pools. Please wait. </template>
            <Column field="id" header="ID" style="width: 4rem" />
            <Column field="name" header="NAME" style="max-width: 10rem" />
            <Column field="description" header="DESCRIPTION" style="max-width: 14rem" />
            <Column field="companies" header="COMPANY COUNT" style="max-width: 14rem">
                <template #body="slotProps">
                    {{ slotProps.data.companies.length }}
                </template>
            </Column>
            <Column field="actions" header="ACTIONS">
                <template #body="slotProps">
                    <Button icon="pi pi-eye" class="p-button-rounded p-button-info mr-2" @click="viewDetails(slotProps.data.id)" v-tooltip="'View Pool Details'" />
                    <Button icon="pi pi-plus-circle" class="p-button-rounded p-button-warning mr-2" @click="configCompanies(slotProps.data.id)" v-tooltip="'Configure Companies'" />
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="editDetails(slotProps.data.id)" v-tooltip="'Edit Pool Details'" />
                    <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2" @click="confirmDelete(slotProps.data.id)" v-tooltip="'Delete Block'" />
                </template>
            </Column>
        </DataTable>
        <!-- Pool Details -->
        <pool-details v-if="detailsDialog" @hide-dialog="detailsDialog = false" />
        <!-- Pool form for editing pool details -->
        <pool-form v-if="editDialog" mode="edit" @hide-dialog="editDialog = false" />
        <!-- Pool Companies dialog to operate companies addition and removal -->
        <pool-companies v-if="configCompanyDialog" @hide-dialog="configCompanyDialog = false" />
    </div>
</template>

<script setup>
import PoolDetails from './PoolDetails.vue';
import PoolForm from './PoolForm.vue';
import PoolCompanies from './PoolCompanies.vue';
import { ref, computed, onMounted } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import { usePoolStore } from '../store';
import { storeToRefs } from 'pinia';
import { buildPagination, getPage, getPerPage, setPage, setPerPage } from '@/composables/PaginationComposable';

const toast = useToast();
const confirm = useConfirm();
const store = usePoolStore();

const { params, loading, totalRecords } = storeToRefs(store);

const pageList = 'companyPoolList';

// all pools
const allPools = computed(() => {
    return store.pools;
});

const offset = computed(() => {
    console.log('offset::computed', getPage(pageList), getPerPage(pageList))
    return getPage(pageList) * getPerPage(pageList)
})

const numberOfRows = computed(() => {
    return getPerPage(pageList)
})

const detailsDialog = ref(false);
const editDialog = ref(false);
const configCompanyDialog = ref(false);

onMounted(async () => {
    buildPagination(pageList, 0, 10, [{field: "id", order: -1}])
    await loadPools();

    console.log('totalRecords', totalRecords)
});

const onPage = async (event) => {
    setPage(pageList, event.page)
    setPerPage(pageList, event.rows)

    params.value = event;
    await loadPools();
};

const loadPools = async () => {
    await store.fetchAllPools(params.value, pageList);
};

const viewDetails = (id) => {
    store.setActivePoolDetails(id);
    detailsDialog.value = true;
};

const configCompanies = (id) => {
    configCompanyDialog.value = true;
    store.setupPoolCompanies(id);
};

const editDetails = (id) => {
    store.editPool(id);
    editDialog.value = true;
};

const confirmDelete = (id) => {
    confirm.require({
        header: 'Delete Confirmation',
        message: 'Are you sure you want to the pool ' + id + '?',
        icon: 'pi pi-info-circle',
        accept: async () => {
            await store.deletePool(id);
        },
        reject: () => {
            toast.add({ severity: 'error', summary: 'Rejected', detail: 'Cancelled', life: 5000 });
        },
    });
};
</script>
